namespace GeniuzPOS.Lookups {
    export namespace LookupSupplierService {
        export const baseUrl = 'Lookups/LookupSupplier';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LookupSupplierRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Lookups/LookupSupplier/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>LookupSupplierService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
